import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-sql",
  "use": "icon-op-sql-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-sql\"><path d=\"M5 4.9v1.3H2.3v1.4h1.3c.4 0 .7.1 1 .4.3.2.4.5.4.9v1.3c0 .4-.1.7-.4.9-.3.3-.6.5-.9.5H1v-1.4h2.7V8.9H2.3c-.4 0-.7-.1-1-.4Q1 8.2 1 7.6V6.3c0-.4.1-.7.4-1s.6-.4 1-.4zm3.7 0c.4 0 .7.2 1 .4s.3.6.3 1v4c0 .4-.1.7-.4.9s-.6.4-.9.4v1.3H7.3v-1.3c-.4 0-.7-.2-1-.4-.2-.3-.3-.6-.3-1v-4c0-.3.1-.6.4-.9s.6-.4 1-.4zm-1.4 5.3h1.3v-4H7.3zm5-5.3v5.3H15v1.4h-4V4.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol